import React, { useMemo } from "react";

// Ambient sparkle field. Pure CSS animated for performance.
export const Sparkles = ({ count = 36, className = "" }) => {
  const dots = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const top = Math.random() * 100;
      const left = Math.random() * 100;
      const size = 2 + Math.random() * 4;
      const delay = Math.random() * 4;
      const duration = 2.5 + Math.random() * 3.5;
      return { top, left, size, delay, duration, i };
    });
  }, [count]);

  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      data-testid="sparkles-layer"
    >
      {dots.map((d) => (
        <span
          key={d.i}
          className="sparkle"
          style={{
            top: `${d.top}%`,
            left: `${d.left}%`,
            width: `${d.size}px`,
            height: `${d.size}px`,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

export default Sparkles;
